import { IFormExceptionDto } from '@models/exceptions/form-error-dto';
import { ResponseDto } from '@models/exceptions/response-dto';
import {
  userAddressFieldReference,
  userBasicDataFieldReference,
} from '../requitred-fields-config';

const API_LABEL_ALIASES: Record<string, string> = {
  NOME: 'usuTxNome',
  BANCO: 'banNrId',
  CIDADE: 'cidNrId',
};

export function normalizeUserFormApiLabel(label: string): string {
  const basicField =
    userBasicDataFieldReference[
      label as keyof typeof userBasicDataFieldReference
    ];
  if (basicField) {
    return basicField;
  }

  const addressField =
    userAddressFieldReference[label as keyof typeof userAddressFieldReference];
  if (addressField) {
    return addressField;
  }

  return API_LABEL_ALIASES[label] ?? label;
}

export function withNormalizedUserFormErrorLabels(
  error: ResponseDto<unknown>,
): ResponseDto<unknown> {
  if (error.type !== 1 || !error.response) {
    return error;
  }

  const formException = error.response as IFormExceptionDto;
  return {
    ...error,
    response: {
      ...formException,
      errors: formException.errors.map((fieldError) => ({
        ...fieldError,
        label: normalizeUserFormApiLabel(fieldError.label),
      })),
    },
  };
}
